// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"7faa6810","498":"8826875f","703":"307c13cb"}[chunkId] + ".chunk.js";
};